// extracted by mini-css-extract-plugin
export var toggleContainer = "ToggleButton-module--toggleContainer--gSQuL";
export var dialog_btn = "ToggleButton-module--dialog_btn--qQzcI";
export var disable = "ToggleButton-module--disable--jVDuQ";
export var bgPrimary = "ToggleButton-module--bg-primary--Yf7XZ";
export var bgSecondary = "ToggleButton-module--bg-secondary--lI8ni";
export var bg__tertiary = "ToggleButton-module--bg__tertiary--Kl6Rx";
export var bg__tertiary_track = "ToggleButton-module--bg__tertiary_track--3hjTB";